<template>
  <div>
    <div v-if="langSet == 'zh'" v-title data-title="新闻"></div>
    <div v-if="langSet == 'en'" v-title data-title="News"></div>
    <!-- 头部 -->
    <top></top>
    <el-row>
      <el-col :xs="1" :sm="3" :md="4" :lg="5" :xl="6"></el-col>
      <el-col :xs="22" :sm="18" :md="16" :lg="14" :xl="12">
        <div class="mainwrap container newswrap" :style="{ minHeight: height }">
          <div>
            <el-row
              class="news"
              v-for="item in newsList"
              :key="item.id"
              @click.native="toNewsDetail(item)"
            >
              <el-col>
                <div v-if="item.style == 4"></div>
                <div v-else>
                  <div
                    v-if="langSet == 'zh' || item.en_title.length == 0"
                    class="news-title"
                  >
                    {{ item.title }}
                  </div>
                  <div
                    v-if="langSet == 'en' && item.en_title.length > 0"
                    class="news-title"
                  >
                    {{ item.en_title }}
                  </div>
                  <!-- <div v-if="langSet == 'zh' || item.en_title.length == 0" class="news-title">{{item.title}}</div>
                  <div v-if="langSet == 'en' && item.en_title.length > 0" class="news-title">{{item.en_title}}</div> -->
                  <img
                    class="img"
                    :src="
                      $imgUrl + (item.thumb.length > 0 ? item.thumb[0].url : '')
                    "
                    alt=""
                  />
                  <div class="sub">
                    <div v-if="langSet == 'zh'">{{ item.inputtime }}</div>
                    <div v-if="langSet == 'en'">{{ item.en_inputtime }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-pagination
              v-if="newsList.length > 0"
              background
              layout="total,prev, pager, next"
              @current-change="changePage"
              :total="total"
            >
            </el-pagination>
          </div>
          <!-- <div v-for="item in newsList" :key="item.id">
              <div class="home_newsBox" v-if="item.style == 4">
                <div class="home_newsBox_text">
                  <div class="home_newsBox_main">{{item.title}}</div>
                  <div>{{item.inputtime}}</div>
                </div>
                <div class="home_newsBox_img">
                  <img :src="$imgUrl + item.thumb[0].url">
                </div>
              </div>
              <div class="news_one" v-else>
                <div class="news_title">{{item.title}}</div>
                <div wv-if="item.style != 1">
                  <div v-for="(_item, _index) in item.thumb" :key="_index">
                    <img :src="$imgUrl +_item.url">
                  </div>
                </div>
                <div class="sub">
                  <div>{{item.inputtime}}</div>
                </div>
              </div>
            </div> -->
        </div>
      </el-col>
      <el-col :xs="1" :sm="3" :md="4" :lg="5" :xl="6"></el-col>
    </el-row>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import { getNewslist } from "@/api/api";
export default {
  components: {
    top,
    bottom,
  },
  name: "news",
  data() {
    return {
      newsList: [],
      height: "",
      langSet: "",
      page: 1,
      total: 0,
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "zh";
    this.getNlist(this.page);
    this.setHeight();
  },
  methods: {
    setHeight() {
      this.height = window.innerHeight - 145 + "px";
    },
    //新闻资讯
    getNlist(page) {
      let data = this.$qs.stringify({
        page,
        pagesize: 10,
        languageSet: this.langSet == "en" ? "1" : "0",
      });
      getNewslist(data)
        .then((res) => {
          // console.log(res)
          if (res.data.errno == 0) {
            this.newsList = res.data.rst;
            this.total = Number(res.data.errmsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changePage(val) {
      this.page = val;
      this.getNlist(this.page);
    },
    toDetail(id) {
      this.$router.push({ path: "/newsdetails", query: { id } });
    },
    toNewsDetail(item) {
      if (item.http_type == "1") {
        this.$router.push({
          name: "newsdetails",
          query: { id: item.id },
        });
      } else if (item.http_type == "2") {
        if (this.langSet === "zh") {
          window.open(item.http_url_cn, "_blank");
        } else if (this.langSet === "en") {
          window.open(item.http_url_en, "_blank");
        }
      }
    },
  },
};
</script>

<style lang="scss">
.news {
  cursor: pointer;
}
.news .img {
  width: 100%;
  height: 342px;
}
.newswrap {
  padding-bottom: 67px;
}
.newswrap .el-pagination {
  text-align: center;
  background: #eee;
  padding: 6px 5px;
  height: 52px;
  box-sizing: border-box;
  margin-top: 20px;
}
.newswrap .el-pagination button,
.newswrap .el-pagination span:not([class*="suffix"]) {
  height: 36px;
  line-height: 40px;
  font-size: 18px;
  color: #666;
}
.newswrap .el-pager li {
  font-size: 18px;
  color: #666;
}
.newswrap .el-pagination.is-background .btn-next,
.newswrap .el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: #fff;
  border-radius: 50%;
}
.newswrap .el-pagination.is-background .el-pager li {
  width: 41px;
  height: 41px;
  line-height: 41px;
}
.newswrap .el-pagination.is-background .el-pager li:not(.disabled).active,
.newswrap .el-pager li.active {
  background-color: #cac28a;
  color: #fff !important;
}
.newswrap .el-pagination.is-background .btn-next,
.newswrap .el-pagination.is-background .btn-prev {
  background-color: transparent;
}
.newswrap .el-pagination .btn-next .el-icon,
.newswrap .el-pagination .btn-prev .el-icon {
  font-size: 20px;
}
.newswrap .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #cac28a;
}
@media only screen and (max-width: 767px) {
  .news:first-child {
    padding-top: 0;
  }
  .news .img {
    height: 100%;
  }
  .newswrap {
    padding-bottom: 0.67rem;
  }
  .newswrap .el-pagination {
    height: 0.52rem;
    padding: 0.05rem;
  }
  .newswrap .el-pagination button,
  .newswrap .el-pagination span:not([class*="suffix"]) {
    height: 0.36rem;
    line-height: 0.36rem;
    font-size: 12px;
  }
  .newswrap .el-pagination.is-background .el-pager li {
    width: 0.41rem;
    height: 0.41rem;
    line-height: 0.41rem;
  }
  .newswrap .el-pager li {
    font-size: 12px;
  }
  .el-pager,
  .el-pager li {
    vertical-align: middle;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    min-width: auto;
  }
  .newswrap .el-pagination .btn-next .el-icon,
  .newswrap .el-pagination .btn-prev .el-icon {
    font-size: 18px;
  }
}
</style>
